module.exports = __webpack_public_path__ + "img/fast-forward.13963ab2.svg";